var _rect, _rect2, _path, _rect3, _rect4, _rect5, _rect6, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg07Exercise(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.896484,
    y: 0.783447,
    width: 18,
    height: 8,
    rx: 1,
    fill: "#E7E6F0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.39648,
    y: 0.783447,
    width: 9,
    height: 32,
    fill: "#E7E6F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.39648 8.78735H14.3965V16.8412L5.39648 10.8381V8.78735Z",
    fill: "#ABA9C8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.896484,
    y: 24.7834,
    width: 18,
    height: 8,
    rx: 1,
    fill: "#E7E6F0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.8281,
    y: 10.9827,
    width: 13.101,
    height: 5.82265,
    rx: 1,
    transform: "rotate(-18 13.8281 10.9827)",
    fill: "#4841A6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 16.9434,
    y: 9.97168,
    width: 6.55048,
    height: 23.2906,
    transform: "rotate(-18 16.9434 9.97168)",
    fill: "#4841A6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 19.2261,
    y: 27.5947,
    width: 13.101,
    height: 5.82265,
    rx: 1,
    transform: "rotate(-18 19.2261 27.5947)",
    fill: "#4841A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7363 15.4905L24.9662 13.4663L26.7844 19.0622L19.2044 16.931L18.7363 15.4905Z",
    fill: "#353071"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg07Exercise);
export default __webpack_public_path__ + "static/media/07_exercise.8d6bc061e62911b17f9c85ce1ac30732.svg";
export { ForwardRef as ReactComponent };